import { FC, memo } from 'react';
import styles from './styles.module.css';
import { useDataContext } from 'src/contexts';

export const Logo: FC = memo(() => {
  const logoSrc = useDataContext((ctx) => ctx.logo);

  return <img className={styles.logo} src={logoSrc} alt="Playwall's Logo" />;
});
